import { useContext } from 'react'

import { UserDetailsContext } from 'src/context/userDetailsContext'

/**
 * Returns details for the current logged in user
 * @returns {import('src/context/userDetailsContext').User} Details
 */
export function useUser() {
    const { userDetails } = useContext(UserDetailsContext)

    return userDetails
}
